module.exports = __webpack_public_path__ + "img/grade1.18bc27f4.jpg";